import { useState, useEffect } from 'react';
import { CONFIG_CDN_URL } from '../constants';

export const useConfig = (clientId) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const url = `${CONFIG_CDN_URL}/${clientId}/Liveness/configV8.json`;
                const res = await fetch(url);
                if (res.ok) {
                    setConfig(await res.json());
                }
            } catch (e) {}
            finally {
                setLoading(false);
            }
        };
        fetchConfig();
    }, [clientId]);

    return { config, loading };
};
